const footerColumns = [
  {
    title: '浏览',
    links: [
      { label: '今日热度榜', href: '#hot' },
      { label: '最新更新', href: '#feed' },
      { label: '事件脉络', href: '#timeline' },
      { label: '话题索引', href: '#topics' },
    ],
  },
  {
    title: '跟进中',
    links: [
      { label: '争议中事件', href: '#feed' },
      { label: '待证实条目', href: '#feed' },
      { label: '已有结论', href: '#feed' },
      { label: '多角度说法', href: '#angles' },
    ],
  },
  {
    title: '关于',
    links: [
      { label: '整理方式说明', href: '#entry' },
      { label: '信息来源标注', href: '#angles' },
      { label: '订阅每日更新', href: '#subscribe' },
      { label: '纠错与补充', href: '#subscribe' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid gap-8 md:gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center">
                <i className="ri-heart-3-fill text-background-50 text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">糖心小桃</span>
            </div>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-sm">
              把分散的截图、回应和时间点归到同一个事件里，按时间顺序排好，再并列呈现不同角度的说法。看瓜之前，先把脉络理清楚。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs">
                <i className="ri-time-line"></i>
                每日多次更新
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs">
                <i className="ri-scales-3-line"></i>
                多方说法并列
              </span>
            </div>
          </div>

          <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-6 md:gap-8">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4 className="font-heading text-sm font-bold text-foreground-950">{column.title}</h4>
                <ul className="mt-3 space-y-2.5">
                  {column.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        rel="nofollow"
                        className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-foreground-500 leading-relaxed">
            本站内容为公开信息的整理与时间线归纳，不代表对任何一方的最终结论，请理性围观。
          </p>
          <p className="text-xs text-foreground-500 whitespace-nowrap">
            © 2026 糖心小桃 · 事件整理与脉络追踪
          </p>
        </div>
      </div>
    </footer>
  );
}